(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.testimonials-custom-section');

  sections.forEach((section) => {
    const slider = section.querySelector('.testimonials-slider');
    if (!slider) return;

    const slides = section.querySelectorAll('.testimonial-slide');
    const dots = section.querySelectorAll('.testimonials-dot');
    if (slides.length <= 1) return;

    let currentIndex = 0;
    const isAutoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed, 10) * 1000 || 5000;
    let timer = null;

    function goToSlide(index) {
      slides.forEach((s) => s.classList.remove('is-active'));
      dots.forEach((d) => d.classList.remove('is-active'));

      currentIndex = index;
      slides[currentIndex].classList.add('is-active');
      if (dots[currentIndex]) {
        dots[currentIndex].classList.add('is-active');
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', function () {
        const targetIndex = parseInt(this.dataset.targetIndex, 10);
        goToSlide(targetIndex);
        if (isAutoplay) {
          clearInterval(timer);
          startAutoplay();
        }
      });
    });

    function startAutoplay() {
      timer = setInterval(() => {
        const nextIndex = (currentIndex + 1) % slides.length;
        goToSlide(nextIndex);
      }, speed);
    }

    if (isAutoplay) {
      startAutoplay();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
